<template>
    <div class="footer">
        <div class="vcore_container">
            <button class="footer-link vcore_btn"
                    type="button"
                    @click="adminView"
            >
                Admin
            </button>
            <button
                    class="footer-link vcore_btn"
                    type="button"
                    @click="configView"
            >
                Config
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        methods: {
            adminView(){
                this.$router.push("/admin");
            },
            configView(){
                this.$router.push("/config");
            }
        }
    }
</script>

<style scoped lang="scss">
    .vcore_row {
        margin: 0;
    }

    .footer {
        background-color: white;
        border-top: 1px solid #DDDDDD;
        width: 100%;
        height: 36px;
        position: fixed;
        bottom: 0;
    }

    .footer-link {
        background-color: transparent;
        color: #2b78e4;
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        height: 36px;
        padding: 0px 12px;
        margin-right: 6px;
        float: left;
    }


</style>